<div class="action-select-block" [class.has-warning]="!!warningHint">
  <!-- Header with Label and Action Button (e.g. + New) -->
  <div class="action-select-header" *ngIf="showHeader && (label || showActionBtn)">
    <span class="action-select-label" *ngIf="label">
      {{ label }}<span *ngIf="required" class="required-star"> *</span>
    </span>
    <button
      *ngIf="showActionBtn"
      type="button"
      class="action-header-btn"
      (click)="onActionClick.emit()"
    >
      <i [class]="actionBtnIcon"></i>
      <span>{{ actionBtnText }}</span>
    </button>
  </div>

  <!-- Select Dropdown & Side Action Button Row -->
  <div class="action-select-row">
    <hospitality-bot-select
      class="main-select"
      [controlName]="controlName"
      [label]="showHeader ? '' : label"
      [options]="options"
      [loading]="loading"
      [disabled]="disabled"
      [isAppendToBody]="isAppendToBody"
      [panelStyleClass]="panelStyleClass"
      [props]="selectProps"
      (itemSelection)="itemSelection.emit($event)"
    >
      <!-- Selected Item Display -->
      <ng-template #selectedItemTemplate let-option>
        <div class="action-select-option">
          <div class="action-select-option__main">
            <span class="action-select-option__label">{{ option?.label }}</span>
            <hospitality-bot-status-chip
              *ngIf="showStatusChip && (option?.status || option?.state || option?.statusConfig)"
              [status]="option?.status || option?.state"
              [variant]="option?.statusVariant || option?.variant"
              [config]="option?.statusConfig || statusChipConfig"
            ></hospitality-bot-status-chip>
          </div>
        </div>
      </ng-template>

      <!-- Dropdown Option Item Display -->
      <ng-template #optionTemplate let-option>
        <div class="action-select-option">
          <div class="action-select-option__main">
            <span class="action-select-option__label">{{ option?.label }}</span>
            <hospitality-bot-status-chip
              *ngIf="showStatusChip && (option?.status || option?.state || option?.statusConfig)"
              [status]="option?.status || option?.state"
              [variant]="option?.statusVariant || option?.variant"
              [config]="option?.statusConfig || statusChipConfig"
            ></hospitality-bot-status-chip>
          </div>
          <span
            class="action-select-option__amount"
            *ngIf="showAmount && option?.amount != null"
          >
            {{ option.amount | dynamicCurrency }}
          </span>
        </div>
      </ng-template>
    </hospitality-bot-select>

    <!-- Side Button (e.g. Preview eye, View, Edit) -->
    <hospitality-bot-button
      *ngIf="showSideBtn"
      class="side-action-btn"
      variant="outlined"
      [piIcon]="sideBtnIcon"
      minWidth="44px"
      height="45px"
      [disabled]="sideBtnDisabled"
      (onClick)="onSideBtnClick.emit()"
      [pTooltip]="sideBtnTooltip"
      tooltipPosition="top"
    ></hospitality-bot-button>
  </div>

  <!-- Notice when options are empty -->
  <div
    class="no-items-notice"
    *ngIf="showEmptyNotice && !loading && (!options || options.length === 0)"
  >
    <div class="notice-text">
      <i class="pi pi-info-circle"></i>
      <span>{{ emptyNoticeText }}</span>
    </div>
    <hospitality-bot-button
      *ngIf="showEmptyActionBtn"
      [label]="emptyActionBtnText"
      [piIcon]="emptyActionBtnIcon"
      variant="outlined"
      (onClick)="onActionClick.emit()"
    ></hospitality-bot-button>
  </div>

  <!-- Warning hint -->
  <div class="form-hint text-warning" *ngIf="warningHint">
    {{ warningHint }}
  </div>

  <!-- Informational hint -->
  <div class="form-hint" *ngIf="hint">
    <i class="pi pi-eye inline-icon" *ngIf="showHintIcon"></i>
    <span>{{ hint }}</span>
  </div>
</div>
